import { useT } from "../lib/i18n";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function RefundPolicy() {
  const { t } = useT();
  return (
    <div className="min-h-screen bg-[#F8F5F2] text-[#1A1A1A]">
      <div className="max-w-3xl mx-auto px-4 md:px-8 py-16">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-ink2 hover:text-[#6E1A24] mb-8">
          <ArrowLeft className="w-4 h-4" /> {t("nav.program") ? "← Back" : "← Back"}
        </Link>
        <h1 className="heading-poster text-4xl md:text-5xl mb-8">Refund Policy / Polityka zwrotów</h1>
        <div className="prose prose-lg max-w-none space-y-6 text-ink2">
          <h2>English</h2>
          <p>Refunds are available up to 7 (seven) calendar days before the event date. After this period, tickets are non-refundable.</p>
          <p>To request a refund, please contact us via the contact form on our website or via Telegram at <a href="https://t.me/yepgt" className="text-[#6E1A24]">@yepgt</a>.</p>
          <p>Refunds will be processed within 5–10 business days to the original payment method.</p>
          <p>If the event is cancelled by the organizer, all ticket holders will receive a full refund.</p>

          <hr className="border-[#E2D8CF]" />

          <h2>Polski</h2>
          <p>Zwrot biletu jest możliwy do 7 (siedmiu) dni kalendarzowych przed datą wydarzenia. Po tym terminie bilety nie podlegają zwrotowi.</p>
          <p>Aby poprosić o zwrot, skontaktuj się z nami przez formularz kontaktowy na stronie lub przez Telegram: <a href="https://t.me/yepgt" className="text-[#6E1A24]">@yepgt</a>.</p>
          <p>Zwroty są realizowane w ciągu 5–10 dni roboczych na oryginalną metodę płatności.</p>
          <p>W przypadku odwołania wydarzenia przez organizatora, wszyscy posiadacze biletów otrzymają pełny zwrot.</p>
        </div>
      </div>
    </div>
  );
}
